import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  container: {
    background: '#f5f5f5',
  },
}));
